// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"818":"1a709d64","963":"c5b56eab"}[chunkId] + ".chunk.js";
};